import { Pipe, PipeTransform } from '@angular/core';
import { Functions } from '../helpers';

@Pipe({
  name: 'phone',
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  transform(value: string | number | undefined): string | number | undefined {
    const valueLength = `${value}`.length;
    if (!value || valueLength < 10) return value;
    return Functions.formatPhone(`${value}`);
  }
}
